import Image, { StaticImageData } from 'next/image'

import theme from '@ilg-totallymoney/ui/theme'

import useWindowSize from '@hooks/useWindowSize'

interface BackgroundImageRendererProps {
    altText?: string
    backgroundMobile: StaticImageData
    backgroundTabletPlus: StaticImageData
    priority?: boolean
    sizes?: string
}

const BackgroundImageRenderer = ({
    altText = 'Background',
    backgroundMobile,
    backgroundTabletPlus,
    priority = false,
    sizes = '100vw',
}: BackgroundImageRendererProps) => {
    const { width } = useWindowSize()

    const shouldShowMobileBackgroundImage = width && width < theme.small

    return (
        <div aria-disabled="true" style={{ zIndex: 1 }}>
            <Image
                src={
                    shouldShowMobileBackgroundImage
                        ? backgroundMobile
                        : backgroundTabletPlus
                }
                alt={altText}
                sizes={sizes}
                placeholder="empty"
                quality={80}
                priority={priority}
                fill
                style={{
                    objectFit: 'cover',
                }}
            />
        </div>
    )
}

export default BackgroundImageRenderer
